module.exports = __webpack_public_path__ + "static/txtling1-150x150-3c1bc8953f6b10d0d79e747b1d26fbb4.png";